import React from 'react'

export default function Footer() {
  return (
    <div className='bg-transparent '>
      <div className='flex justify-center mx-auto items-center py-5'>
        <div className='border border-2 w-3 rotate-140 h-3 bg-white'></div>
        <div className='border border-2 w-[40%]'></div>
        <div className='w-[120px] h-[120px] '>
          <div className='p-1 rounded-full overflow-hidden relative'>
            <div className='icon-gradient animate-spin-slow'></div>
            <div className='bg-black rounded-full grid place-content-center '>
              <div className=' rounded-full grid place-content-center bg-gradient-to-b from-white/50 to-black/50'>
                <img src='/assets/others/Ball.svg' className='ball-spin-reverse'></img>
              </div>
            </div>
          </div>
        </div>
        <div className='border border-2 w-[40%]'></div>
        <div className='border border-2 w-3 rotate-140 h-3 bg-white'></div>
      </div>
      <div className='w-[90%] lg:w-[85%] flex justify-between mx-auto -translate-y-10 lg:-translate-y-16'>
        <div className='flex flex-col lg:flex-row items-center gap-5'>
          <p className='text-xs'> © {new Date().getFullYear()} Goaldex.com</p>
          <div className='flex items-center gap-3'>
            <a href='https://www.threads.net/@goaldex.ai' target='_blank'><i className='fab fa-threads  text-xl cursor-pointer brand-fade' ></i></a>
            <a href='https://x.com/goaldex_ai?t=aOad5QaScsnvO9TSfW2VOg&s=09' target='_blank'><i className='fab fa-x-twitter text-xl cursor-pointer brand-fade-2' ></i></a>
            <a href='https://www.instagram.com/goaldex.ai/profilecard/?igsh=MWd2N3FnaHlrbzJiMA==' target='_blank'><i className='fab fa-instagram text-xl cursor-pointer brand-fade-3' ></i></a>
            <a href='https://youtube.com/@goaldex?si=9dtF8KOiGTXqCY68' target='_blank'><i className='fab fa-youtube   text-xl cursor-pointer brand-fade-4' ></i></a>
          </div>
        </div>
        <div className='flex flex-col lg:flex-row gap-3'>
          <a href='/assets/files/TOS.pdf' target='_blank' className='text-white'>Terms of Service</a>
          <a href='assets/files/Privacy Policies.pdf' target='_blank' className='text-white'>Privacy Policy</a>
          <a className='text-white'>Cookies</a>
        </div>

      </div>
    </div>
  )
}
